// ABOUTME: Renders the canonical form for creating a Compleo user.
// ABOUTME: Keeps branch access fields hidden and out of canonical submissions.
import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import useCompleoForm from "customHooks/useCompleoForm";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import FormClassic from "customHooks/useCompleoForm/components/FormClassic";
import useFormStyles from "customHooks/useCompleoForm/components/useFormStyles";
import CustomComponents from "./components/UserCustomComponents";
// import { useSelector } from "react-redux";
import { AuthProvider, useAuthState } from "_ReactContext/AuthContext";
import { useApi } from "customHooks/useApi";
import { useNextPageFunctionsNewUser } from "./components/useNextPageFunctionsNewUser";
import { navigate } from "@gatsbyjs/reach-router";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";
import useCustomLists from "./components/useCustomLists";
import { usePlanLimitsPage } from "customHooks/usePlanLimits/usePlanLimits";
import {
    getUserFormFieldsToHide,
    stripUserBranchAccessMetadata,
    stripUserBranchAccessFields
} from "./userFormPolicy";

const UserNew = (props: any) => {
    const cancelFunction = useCancelButtonForm("/user/list");
    const classes = useFormStyles();
    const { company } = useAuthState();
    const [t, i18n, readyTranslation] = useTranslation("usernew", {
        useSuspense: false
    });
    const nextPageFunctions = useNextPageFunctionsNewUser(company.companyId, t);
    const [listDefinition, readyLists] = useCustomLists(t, readyTranslation);
    const { limitReached } = usePlanLimitsPage(t, "/user/list", "addUser");

    const fieldsToHide = getUserFormFieldsToHide();

    const postAddress = `/user/new`;
    const [addUserReturn, addUser] = useApi(postAddress, "post");

    const [metadata] = useGetMetadata("USERNEW");
    const canonicalMetadata = stripUserBranchAccessMetadata(metadata);

    const [valuesFromSource] = useValuesFromSource(
        canonicalMetadata,
        true,
        {}
    );
    // valuesFromSource.companyId = company.companyId;
    valuesFromSource.timeZone =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Sao_Paulo";

    valuesFromSource.enabled = true;
    const canonicalValuesFromSource =
        stripUserBranchAccessFields(valuesFromSource);
    const postUser = React.useCallback(
        (values: any) => addUser(stripUserBranchAccessFields(values)),
        [addUser]
    );

    const [formCompleo, finished] = useCompleoForm(
        classes,
        t,
        props,
        readyTranslation,
        i18n,
        !limitReached ? postUser : undefined,
        addUserReturn,
        "/user/list",
        FormClassic,
        canonicalMetadata,
        canonicalValuesFromSource,
        CustomComponents,
        null,
        nextPageFunctions,
        cancelFunction,
        undefined,
        listDefinition,
        fieldsToHide
    );

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;

    if (finished && readyTranslation) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="md"
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

// UserNew.whyDidYouRender = true;
export default UserNew;
